<div *ngIf="canLoadMore === true" class="d-flex justify-content-center">
    <button type="button" class="btn btn-primary" (click)="onLoadMore()">Load More</button>
</div>